import type { NavItemProps } from '~/utils/nav'

export function useRootNavItem() {
  const { loggedIn } = useUserSession()
  const config = useRuntimeConfig()

  return computed<NavItemProps>(() => {
    const context = getNavigationContext()
    if (context === 'marketing') {
      return navItems.home
    }
    else if (loggedIn.value) {
      return navItems.overview
    }
    else {
      if (config.public.env === 'development') {
        return navItems.laws
      }

      return navItems.home
    }
  })
}

export function useLeftNavItems() {
  return computed(() => leftNavItems[getNavigationContext()])
}

export function useProfileDropdownItems() {
  const isDev = useIsDev()
  const { deleteFavoritesMetadata } = useFavorites()

  return computed<NavItemProps[]>(() => {
    const context = getNavigationContext()
    const items = profileDropdownNavItems[context]

    if (context === 'marketing' || !isDev.value) {
      return items
    }

    return [
      ...items,
      {
        label: '🚨\xA0Delete\xA0Favorites',
        onClick: deleteFavoritesMetadata,
      },
    ]
  })
}

export function useRightNavItems() {
  const { loggedIn, user } = useUserSession()

  const { size } = useCartMetadata()

  const { emphasis } = useButtonEmphasis()

  const profileChildren = useProfileDropdownItems()

  const route = useRoute()

  const context = getNavigationContext()

  return computed<NavItemProps[]>(() => {
    if (!loggedIn.value) {
      return [
        navItems.purchaseSubscription,
        {
          ...navItems.login,
          emphasis: emphasis.value,
          to: {
            ...navItems.login.to,
            query: context === 'default'
              ? { redirectTo: route.fullPath } satisfies RedirectToQuery
              : undefined,
          },
        },
      ]
    }

    const profileDropdown = {
      ...navItems.profile,
      childProps: profileChildren.value,
    }

    if (context === 'default') {
      return [
        navItems.workspace,
        profileDropdown,
      ]
    }

    const useJuridika = { ...navItems.overviewExternal, size: 'small' } satisfies NavItemProps

    if (isAdmin(user) && size.value) {
      return [
        {
          ...navItems.cart,
          badge: size.value,
        },
        profileDropdown,
        useJuridika,
      ]
    }

    return [
      profileDropdown,
      useJuridika,
    ]
  })
}
